//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hasProducts from '~/mixins/hasProducts'
import hasWindow from '~/mixins/hasWindow'

export default {
  mixins: [hasProducts, hasWindow],

  props: { category: { type: Object, default: () => ({}) } },

  computed: {
    productsParams() {
      return {
        category_id: this.category.id,
        limit: 100,
        orderBy: ['priority', 'id'],
      }
    },
  },

  beforeMount() {
    this.maybeFetchProducts(this.productsParams)
  },
}
